import { type IconName } from '@shared/icon';

export type SearchKind = 'patient' | 'document' | 'order';

export interface SearchHit {
  readonly id: string;
  readonly title: string;
  readonly kind: SearchKind;
  readonly description?: string;
}

export interface SearchJumpItem {
  readonly id: string;
  readonly labelKey: string;
  readonly descriptionKey: string;
  readonly icon: IconName;
}

export const SEARCH_KIND_ICON: Record<SearchKind, IconName> = {
  patient: 'person',
  document: 'documentText',
  order: 'clipboard',
};

export const SEARCH_KIND_LABEL: Record<SearchKind, string> = {
  patient: 'header.search.kind.patient',
  document: 'header.search.kind.document',
  order: 'header.search.kind.order',
};

export const SEARCH_GROUP_TITLE: Record<SearchKind, string> = {
  patient: 'header.search.group.patient',
  document: 'header.search.group.document',
  order: 'header.search.group.order',
};

export const SEARCH_KIND_ORDER: readonly SearchKind[] = ['patient', 'document', 'order'];

export const SEARCH_CLEAR_RECENTS = 'search:clear-recents';
export const SEARCH_VIEW_ALL_PREFIX = 'search:view-all:';
export const SEARCH_GROUP_PREVIEW = 3;
export const SEARCH_DEBOUNCE_MS = 300;
export const SEARCH_MAX_LENGTH = 200;

export function searchViewAllValue(kind: SearchKind): string {
  return `${SEARCH_VIEW_ALL_PREFIX}${kind}`;
}
